import { Typography, Grid, Checkbox } from "@mui/material";
import React, { useState, useEffect, forwardRef } from "react";
import { White } from "../../assets/images";
import moment from "moment";
import { isNull } from "lodash";
import { fetchList } from "../../apis/services/CommonApiService";
import { ApiEndPoints } from "../../apis/ApiEndPoints";

// async function getImageBlobFromUrl(url) {
//   const image = await axios
//     .get(url, {
//       responseType: "blob",
//     })
//     .then((response) => window.URL.createObjectURL(new Blob([response.data])));
//   return image;
// }

const PrintAgreement = forwardRef((props, ref) => {

  useEffect(()=>{
    var d1 = document.getElementById("agreement_acceptance");
      if (d1) {
        d1.innerHTML = props?.templateList?.agreement_acceptance;
      }
  },[props?.templateList])

  return (
    <div ref={ref} style={{ backgroundColor: "white" }}>
      <div className="mt-2">
        <div className="pl-3 pr-3">
          <div className="pl-3 pr-3 mt-1">
            <div style={{ display: "flex", justifyContent: "center" }}>
              <u>
                <h1 style={{ fontSize: "20px" }}>Document Detail</h1>
              </u>
            </div>
            {/* <Grid container spacing={0.5} alignItems="flex-start">
                <Grid item lg={4}>
                  <Typography
                    variant="p"
                    style={{ padding: "5px", fontSize: "15px" }}
                  >
                    Booking ID :&nbsp;#
                    {String(props.documentDetail?.id).padStart(6, "0")}
                  </Typography>
                </Grid>
                <Grid item lg={4} sm={4}>
                  <Typography
                    variant="p"
                    style={{ padding: "5px", fontSize: "15px" }}
                  >
                    Name : {this.props.documentDetail?.name}
                  </Typography>
                </Grid>
                <Grid item lg={4} sm={4}>
                  <Typography
                    variant="p"
                    style={{ padding: "5px", fontSize: "15px" }}
                  >
                    Phone : {this.props.documentDetail?.phone_code}
                    {this.props.documentDetail?.phone}
                  </Typography>
                </Grid>
                <Grid item lg={4} sm={4}>
                  <Typography
                    variant="p"
                    style={{ padding: "5px", fontSize: "15px" }}
                  >
                    Email : {this.props.documentDetail?.email}
                  </Typography>
                </Grid>
                <Grid item lg={4} sm={4}>
                  <Typography
                    variant="p"
                    style={{ padding: "5px", fontSize: "15px" }}
                  >
                    Id Number : {this.props.documentDetail?.id_number}
                  </Typography>
                </Grid>
                <Grid item lg={4} sm={4}>
                  <Typography
                    variant="p"
                    style={{ padding: "5px", fontSize: "15px" }}
                  >
                    IATA Number : {this.props.documentDetail?.iata_number}
                  </Typography>
                </Grid>
                <Grid item lg={12} sm={12}>
                  <Typography
                    variant="p"
                    style={{ padding: "5px", fontSize: "15px" }}
                  >
                    Address : {this.props.documentDetail?.address}
                  </Typography>
                </Grid>
                <Grid item lg={4}>
                  <Typography
                    variant="p"
                    style={{ padding: "5px", fontSize: "15px" }}
                  >
                    Country : {this.props.documentDetail?.country_id}
                  </Typography>
                </Grid>
                <Grid item lg={4}>
                  <Typography
                    variant="p"
                    style={{ padding: "5px", fontSize: "15px" }}
                  >
                    State : {this.props.documentDetail?.state_id}
                  </Typography>
                </Grid>
                <Grid item lg={4}>
                  <Typography
                    variant="p"
                    style={{ padding: "5px", fontSize: "15px" }}
                  >
                    City : {this.props.documentDetail?.city_id}
                  </Typography>
                </Grid>
                <Grid item lg={4}>
                  <Typography
                    variant="p"
                    style={{ padding: "5px", fontSize: "15px" }}
                  >
                    Postal Code :{" "}
                    {this.props.documentDetail?.postal_code === "undefined"
                      ? ""
                      : this.props.documentDetail?.postal_code}
                  </Typography>
                </Grid>
              </Grid> */}
            <table style={{ width: "100%" }}>
              <tbody>
                <tr style={{ width: "100%" }}>
                  <td style={{ width: "33%" }}>
                    <div style={{ padding: "5px", fontSize: "16px" }}>
                      Booking ID :&nbsp;#
                      {String(props.documentDetail?.id).padStart(6, "0")}
                    </div>
                  </td>
                  <td style={{ width: "33%" }}>
                    <div style={{ padding: "5px", fontSize: "16px" }}>
                      Name : {props.documentDetail?.name}
                    </div>
                  </td>
                  <td style={{ width: "33%" }}>
                    <div style={{ padding: "5px", fontSize: "16px" }}>
                      Phone : {props.documentDetail?.phone_code}
                      {props.documentDetail?.phone}
                    </div>
                  </td>
                </tr>
                <tr style={{ width: "100%" }}>
                  <td colSpan="3" style={{ width: "33%" }}>
                    <div style={{ padding: "5px", fontSize: "16px" }}>
                      Email : {props.documentDetail?.email}
                    </div>
                  </td>
                  {/* <td style={{ width: "33%" }}>
                    <div style={{ padding: "5px", fontSize: "16px" }}>
                      Id Number : {this.props.documentDetail?.id_number}
                    </div>
                  </td>
                  <td style={{ width: "33%" }}>
                    <div style={{ padding: "5px", fontSize: "16px" }}>
                      IATA Number : {this.props.documentDetail?.iata_number}
                    </div>
                  </td> */}
                </tr>
              </tbody>
            </table>
            <div style={{ width: "100%" }}>
              <div style={{ padding: "5px", fontSize: "16px" }}>
                Address : {props.documentDetail?.address}
              </div>
            </div>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr style={{ width: "100%" }}>
                  <td style={{ width: "33%" }}>
                    <div style={{ padding: "5px", fontSize: "16px" }}>
                      Country : {props.documentDetail?.country_id}
                    </div>
                  </td>
                  <td style={{ width: "33%" }}>
                    <div style={{ padding: "5px", fontSize: "16px" }}>
                      State : {props.documentDetail?.state_id}
                    </div>
                  </td>
                  <td style={{ width: "33%" }}>
                    <div style={{ padding: "5px", fontSize: "16px" }}>
                      City : {props.documentDetail?.city_id}
                    </div>
                  </td>
                </tr>
                <tr style={{ width: "100%" }}>
                  <td style={{ width: "33%" }}>
                    <div style={{ padding: "5px", fontSize: "16px" }}>
                      Postal Code :{" "}
                      {props.documentDetail?.postal_code === "undefined"
                        ? ""
                        : props.documentDetail?.postal_code}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginRight: "20px",
                marginLeft: "20px",
                borderTop: "2px solid",
                marginTop: "15px",
              }}
            ></div> */}
        </div>
        <div className="pl-3 pr-3 mt-1">
          {/* <div style={{ display: "flex", justifyContent: "center" }}>
              <u>
                <h1 style={{ fontSize: "20px" }}>Payment Detail</h1>
              </u>
            </div> */}
          <Grid container spacing={2} alignItems="flex-start" className="pl-3">
            {/* <Grid item lg={4}>
                <Typography
                  variant="subtitle1"
                  style={{ padding: "5px", fontSize: "15px" }}
                >
                  Payment Type :{" "}
                  {getPaymentTypeOfBooking(
                    this.props.documentDetail?.payment_type
                  )}
                </Typography>
              </Grid> */}
            {/* <Grid item lg={4}>
                <Typography
                  variant="subtitle1"
                // style={{ padding: "5px", fontSize: "15px" }}
                >
                  Payment Type :{" "}
                  {getPaymentTypeOfBooking(
                    this.props.documentDetail?.payment_type
                  )}
                </Typography>
              </Grid> */}
            {props.paymentDetail?.card_holder_name && (
              <>
                <Grid item lg={4}>
                  <Typography
                    variant="subtitle1"
                    style={{ padding: "5px", fontSize: "15px" }}
                  >
                    Card Holder Name : {props.paymentDetail?.card_holder_name}
                  </Typography>
                </Grid>
                <Grid item lg={4}>
                  <Typography
                    variant="subtitle1"
                    style={{ padding: "5px", fontSize: "15px" }}
                  >
                    Card Number : {props.paymentDetail?.card_number}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "20px",
              marginLeft: "20px",
              borderTop: "2px solid",
              marginTop: "15px",
            }}
          ></div>
        </div>
        <div className="pl-3 pr-3 mt-1">
          <div style={{ display: "flex", justifyContent: "center" }}>
            <u>
              <h1 style={{ fontSize: "20px" }}>GENERAL RELEASE AGREEMENT</h1>
            </u>
          </div>
          <div className="pl-3 pr-3">
            <div
              style={{
                marginTop: "10px",
                fontSize: "16px",
              }}
              id="release_print"
              dangerouslySetInnerHTML={{
                __html:
                  '<div style={{fontSize: "12px"}}>' +
                  props?.templateList?.general_release +
                  "<div>",
              }}
            >
              {/* <ul>
                  <li>Check out is 11:00am</li>
                  <li>
                    All reservations are subject to a $150.00 refundable
                    incidental authorization. This will be released at the time
                    of check out. Please note that depending on your bank it may
                    take up to 7-10 business days to reflect back into your bank
                    account.
                  </li>

                  <li>
                    Should there be any damages to the Property or Room by you
                    or anyone in your party, you will be charged for all costs.
                  </li>

                  <li>
                    Medically Trained Service Animals are welcomed, however pets
                    are NOT allowed in our rooms. If pets are detected in the
                    room, you will be charged a $250 deep cleaning fee. If you
                    are bringing a Service Animal, please reach out to let us
                    know.
                  </li>

                  <li>
                    Late check out subject to availability, by request only.
                    Late check out fee $25. Full daycharge after 1:00pm
                  </li>
                  <li>
                    We are a Non-Smoking property. A $250.00 fine will be
                    charged to your credit card on file if smoking is detected
                    in your room.{" "}
                  </li>
                  <li>
                    Mid-Stay housekeeping/refreshes available upon request with
                    24 hours notice
                  </li>
                  <li>
                    Hotel is not responsible for any injuries, damages, lost or
                    stolen property. Hotel reserves the right to ask a guest to
                    leave without refund should there be a disturbance caused
                  </li>
                </ul> */}

              {/* &emsp;&emsp;&emsp;&emsp;&emsp;This rate is eligible for partner
                rewords. If this rate is changed, you may no longer be entited
                to Choice Privileges points. */}
            </div>
            <p
              style={{
                marginTop: "10px",
                fontSize: "13px",
              }}
            >
              {/* &emsp;&emsp;&emsp;&emsp;&emsp;1st night & tax collection prior
                to check-in. Prepayment for the entire stay is required at Front Desk
                to avoid a $200.00 fee. Smoking in rooms $250.00 cleaning fee.
                The hotel is not responsible for any injuries, damages, lost or
                stolen property. The hotel reserves the right to ask a guest to leave
                without a refund. Provide your email to receive our latest
                information & updates. I understand all items "Your email will
                not be shared". */}
            </p>
          </div>
        </div>
        <div className="pl-3 pr-3 ">
          <Grid container className="mt-1 pl-3 pr-3">
            <Grid item lg={4}>
              <Typography
                variant="h4"
                style={{
                  marginBottom: "11px",
                  color: "rgb(30, 30, 30)",
                  fontSize: "14px",
                }}
              >
                Guest Signature : -
              </Typography>
              {props?.signature === null ? (
                <img
                  src={White}
                  // className="mt-2"
                  alt="signature"
                  style={{
                    border: "3px solid black",
                    width: "140px",
                    height: "150px",
                    marginRight: "10px",
                    marginLeft: "20px",
                  }}
                />
              ) : (
                <img
                  src={props.signature}
                  alt="signature"
                  style={{
                    border: "1px solid black",
                    width: "150px",
                    height: "150px",
                  }}
                />
              )}
            </Grid>
            <Grid item lg={6} className="pl-3 pr-3">
              <table
                style={{
                  border: "0",
                  width: "100%",
                  // left: "60px",
                  fontSize: "10px",
                  cellspacing: "0",
                  cellpadding: "0",
                }}
              >
                <tbody style={{ top: "30px" }}>
                  <tr>
                    <td colSpan="3">
                      <Typography
                        variant="h4"
                        style={{ textTransform: "capitalize" }}
                      >
                        {props?.documentDetail?.company_name}
                      </Typography>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="6">
                      <Typography
                        variant="subtitle1"
                        style={{ textTransform: "capitalize" }}
                      >
                        <span>{props?.documentDetail?.company_address}</span>
                      </Typography>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="6">
                      <Typography
                        variant="subtitle1"
                        style={{ textTransform: "capitalize" }}
                      >
                        <span>
                          Tel: {props?.documentDetail?.company_phone_code}{" "}
                          {props?.documentDetail?.company_phone}
                        </span>
                      </Typography>
                    </td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <td>
                      <Typography variant="h4">Name:</Typography>
                      <Typography variant="subtitle1">
                        <span style={{ textTransform: "capitalize" }}>
                          {props?.documentDetail?.name}
                        </span>
                      </Typography>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>
          </Grid>
        </div>
        {/* <div className="pl-3 pr-3 mt-1 pb-2" >
            <div className="pl-3 pr-3">
              <p
                style={{
                  marginTop: "5px",
                  fontSize: "13px",
                }}
              >
                &emsp;&emsp;&emsp;&emsp;&emsp;I agree that my liability for this
                bill is not waived and agree to be help personally liable in the
                event that the indicated person, company, or association fails to
                pay the full amount of these charges.
              </p>
              <p
                style={{
                  marginTop: "5px",
                  fontSize: "13px",
                }}
              >
                &emsp;&emsp;&emsp;&emsp;&emsp;For reservations at this hotel
                please call {this.props.documentDetail?.company_phone}, or make
                reservations at another Quality Inn & {this.props.documentDetail?.company_name} Please  call {this.props.documentDetail?.company_phone}.
              </p>
            </div>
          </div> */}
        {/* <div className="page-break" style={{pageBreakAfter:"always"}} /> */}
        <div style={{ breakBefore: "page" }}></div>

        <div className="px-3">
          <Grid
            container
            // spacing={2}
            sx={{ marginTop: "10px" }}
            className="pl-3 pr-3"
          >
            <Typography sx={{ top: "30px" }} id="text-bold">
              CreditCard Authorization *
            </Typography>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                textAlign: "justify",
                verticalAlign: "text-top",
                alignItems: "baseline",
                marginTop: "20px",
              }}
            >
              <Checkbox checked style={{ top: "10px", color: "gray" }} />

              <Typography
                className="checkboox_countent pr-3"
                style={{ textTransform: "capitalize" }}
              >
                {/* I agree that my liability for this bill is not waived
                      and agree to be help personally liable in the event that
                      the indicated person, company, or association fails to
                      pay the full amount of these charges. */}
                I authorize The {props?.documentDetail.company_name}{" "}
                {props?.templateList?.credit_card_authorization}
                {/* to
                place a hold on my credit card on file for the balance due, plus
                a $100 hold for incidentals. This hold will be released upon
                checkout less the cost of any incidentals. */}
              </Typography>
            </Grid>
            <Typography sx={{ top: "30px" }} id="text-bold">
              Signature Accept Terms *
            </Typography>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                textAlign: "justify",
                verticalAlign: "text-top",
                alignItems: "baseline",
                marginTop: "20px",
              }}
            >
              <Checkbox checked style={{ top: "10px", color: "gray" }} />

              <Typography className="checkboox_countent ">
                {/* I agree that my liability for this bill is not waived
                      and agree to be help personally liable in the event that
                      the indicated person, company, or association fails to
                      pay the full amount of these charges. */}
                I agree to pay all charges accrued.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <p
                style={{
                  fontSize: "16px",
                  top: "15px",
                  textAlign: "justify",
                  // marginBottom: "100px",
                }}
                className=" pr-3"
              >
                For reservations at this hotel please call{" "}
                {props?.documentDetail?.company_phone_code}{" "}
                {props?.documentDetail?.company_phone}.
                {/* , or make reservations
                at another Quality Inn &{" "}
                {this.props?.documentDetail?.company_name} Please call{" "}
                {this.props?.documentDetail?.company_phone}. */}
              </p>
            </Grid>
          </Grid>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginRight: "20px",
            marginLeft: "20px",
            borderTop: "2px solid",
            marginTop: "30px",
            marginBottom: "30px",
          }}
        ></div>
        <div className="px-3">
          <Grid container className="px-3" alignItems="flex-start">
            <Grid item lg={12} style={{ width: "100%" }}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <h1 style={{ fontSize: "20px" }}>ID Proof</h1>
              </div>
              <div id="release_print">
                <ul>
                  <li id="text-bold">
                    Please verify your identity by uploading a photo of your
                    government issued photo ID.
                  </li>
                  <li>
                    Please be sure that your name, photo and date of birth are
                    visible.
                  </li>
                </ul>
              </div>
              <div className="mt-2">
                <div id="text-bold">ID Proof Type : </div>{" "}
                <div>
                  {props?.documentDetail?.id_proof_type === 1
                    ? "Passport"
                    : props?.documentDetail?.id_proof_type === 2
                    ? "Driving License"
                    : ""}{" "}
                </div>
              </div>
            </Grid>
            {/* <Grid
              item
              lg={12}
              direction="row"
              justifyContent="center"
              alignItems="center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {this.props.documentDetail.id_proof === null ||
              this.props.documentDetail.id_proof === "undefined" ? (
                <img
                  src={White}
                  // className="mt-2"
                  alt="proof"
                  style={{
                    border: "1px solid black",
                    width: "150px",
                    height: "150px",
                    marginRight: "10px",
                  }}
                />
              ) : (
                <img
                  style={{
                    width: "30%",
                    height: "auto",
                    zIndex: "99",
                  }}
                  src={this.props?.documentDetail?.id_proof}
                  alt={
                    this.props.documentDetail.id_proof === null ||
                    this.props.documentDetail.id_proof === undefined
                      ? null
                      : typeof this.props?.documentDetail?.id_proof != "string"
                      ? URL.createObjectURL(
                          this.props?.documentDetail?.id_proof
                        )
                      : this.props?.documentDetail?.id_proof
                  }
                />
              )}
            </Grid> */}
            <Grid item lg={12} style={{ width: "100%" }}>
              <div className="mt-2">
                <div id="text-bold">IP Address : </div>{" "}
                <div>{props?.ipAddress ? props?.ipAddress : ""}</div>
              </div>
              <div className="mt-2">
                <div id="text-bold">Date Submitted : </div>{" "}
                <div>{moment().format()}</div>
              </div>
              <div className="mt-2">
                <div id="text-bold">Browser User Agent : </div>{" "}
                <div>{!isNull(props?.userAgent) ? props?.userAgent : ""}</div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
});

export default PrintAgreement;
